import { Badge, Tooltip, TooltipContent, TooltipTrigger } from "@aircall/ds";

import type { ExtraItemsProps } from "./ExtraItems.decl";
import { ItemsList } from "./ExtraItemsList";

/**
 * @param items - Array of objects with id and text properties
 * @returns Counter of items with tooltip information
 */
export function ExtraItems({ items }: ExtraItemsProps) {
  return (
    <Tooltip>
      <TooltipTrigger render={<Badge color="charcoal" tone="light" />}>
        {`+${items.length}`}
      </TooltipTrigger>
      <TooltipContent>
        <ItemsList items={items} />
      </TooltipContent>
    </Tooltip>
  );
}
